import { render, staticRenderFns } from "./ResearchStackedBarPlot.vue?vue&type=template&id=525a4301&scoped=true"
import script from "./ResearchStackedBarPlot.vue?vue&type=script&lang=js"
export * from "./ResearchStackedBarPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchStackedBarPlot.vue?vue&type=style&index=0&id=525a4301&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a4301",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525a4301')) {
      api.createRecord('525a4301', component.options)
    } else {
      api.reload('525a4301', component.options)
    }
    module.hot.accept("./ResearchStackedBarPlot.vue?vue&type=template&id=525a4301&scoped=true", function () {
      api.rerender('525a4301', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchStackedBarPlot.vue"
export default component.exports